// A prize can have several winners when players tie (ticket bdec6a1f).
// get_prizes / get_group_prizes return them as `winners`; the single `winner`
// object is the first of them and only kept for older clients.

/** The winners of a prize as [{ id, full_name, ... }], never null. */
export function getPrizeWinners(prize) {
  if (!prize) return []
  if (Array.isArray(prize.winners)) return prize.winners
  if (prize.winner) return [prize.winner]
  return []
}

export function hasPrizeWinner(prize) {
  return getPrizeWinners(prize).length > 0
}

/** "Ann", "Ann and Bo", "Ann, Bo and Cy". */
export function formatWinnerNames(winners) {
  const names = (winners || []).map((w) => w?.full_name || 'Unknown')
  if (names.length <= 1) return names[0] || ''
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`
}
